export const POSITION = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
}
export const TRIGGER = {
  HOVER: 'hover',
  CLICK: 'click'
}
